module.exports = __webpack_public_path__ + "static/img/133.5d9f21a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/133.jpg
// module id = GXrH
// module chunks = 0